import FieldProto from "../../../proto/field-proto"
import FieldConfig from "../../../proto/field-config"
import FieldCheckbox_View from "./render/view"
import FieldCheckbox_ViewSmall from "./render/view-small"
import {GROUP_BOOL} from "../../../../gd/const/fields/field2-groups"
import FieldCheckbox_ManagementForm from "./render/management-form"
import FieldCheckbox_ManagementPreview from "./render/management-preview"
import FieldCheckbox_FormElement from "./render/form-element"
import FieldCheckbox_InlineEditable from "./render/inline-editable"
import FieldCheckbox_AutomationTriggerForm from "./render/automation-trigger"
import FieldCheckbox_AutomationConditionForm from "./render/automation-condition"
import FieldCheckbox_AutomationActionForm from "./render/automation-action"
import normalizeBoolean from "../../../import/normalize/normalize-boolean"
import ImportFromCSVModule from "../../../../gd-modules/import-from-csv/import-from-csv-module"
import FieldCheckbox_FormElementView from "./render/form-element-view"
import FieldCheckbox_Editable from "./render/editable/editable"
import FieldCheckbox_TableCell from "./render/table/table-cell"
import {FieldFilterType} from "../../../proto/types"
import AggregateBooleanComponent from "../../../../fields/custom/boolean/components/aggregate-boolean";
import AggregateBoolean from "../../../../fields/aggregate/aggregate-boolean";

export default class FieldCheckbox extends FieldProto {

    FIELD_DEFAULT_WIDTH: number = 100

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Checkbox"
        this.typeGroup          = GROUP_BOOL
        this.typeDescription    = "Form checkbox field"

        this.filterType         = FieldFilterType.BOOLEAN;
        this.icon               = 'i5-checkbox';

        this.isSearchable       = false;

        // core/gd-form/common/form-manager
        this.formType           = 'select';
        this.formInitValue      = false;

        //checkbox specific
        this.size               = _.get(config, 'size', 16)
        this.renderType         = _.get(config, 'renderType', 'square')

        this.components = {};

        this.renderComponents.view                    = FieldCheckbox_View
        this.renderComponents.viewSmall               = FieldCheckbox_ViewSmall
        this.renderComponents.inlineEditable          = FieldCheckbox_InlineEditable

        this.renderComponents.managementForm          = FieldCheckbox_ManagementForm
        this.renderComponents.managementPreview       = FieldCheckbox_ManagementPreview

        this.renderComponents.formElement             = FieldCheckbox_FormElement
        this.renderComponents.formElementView         = FieldCheckbox_FormElementView

        this.renderComponents.automationTriggerForm   = FieldCheckbox_AutomationTriggerForm
        this.renderComponents.automationConditionForm = FieldCheckbox_AutomationConditionForm
        this.renderComponents.automationActionForm    = FieldCheckbox_AutomationActionForm


        this.renderComponents.editable                = FieldCheckbox_Editable
        this.renderComponents.tableCell               = FieldCheckbox_TableCell
    }

    sortValue(value:any) { return value ? 1 : 0 }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        return normalizeBoolean(value)
    }


    // *** Aggregate for Field1 support ***

    // getAggregateValue(model:any) {
    //     debug && console.log(debug, 'getAggregateValue', this.fieldId, this.getViewValue(model), model)
    //     return this.getViewValue(model)
    // }

    get AggregateComponent() {return AggregateBooleanComponent.bind(null, this.getAggregateOptions())}

    getAggregateClass() {return AggregateBoolean}

    getAggregateOptions() {return [
        gd.const.aggregate.type.CHECKED_TOTAL,
        /*gd.const.aggregate.type.CHECKED_NOT_CHECKED,*/
    ]}
    getDefaultAggregateFunction() {
        return gd.const.aggregate.type.CHECKED_TOTAL
    }
    // *** End ***


}
